<template>
  <div>
    <!-- <Tab :index="index" @tap="tapFn"></Tab> -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>营销运营管理</el-breadcrumb-item>
    </el-breadcrumb> -->
    <!-- 表单提交模块 -->
    <el-row :gutter="20">
      <!-- 左侧表单 -->
      <el-col :span="14">
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">客户信息录入</span>
            </el-col>
          </el-row>
          <div class="flex">
            <!-- <div class="btns">
              <div class="btn" :class="activeIndex === 0 ? 'active' : ''" @click="activeIndex = 0">B端客户信息</div>
              <div class="btn" :class="activeIndex === 1 ? 'active' : ''" @click="activeIndex = 1">C端选手信息</div>
            </div> -->
            <el-form v-if="activeIndex === 0" class="form" :model="editInfoForm" label-width="120px" ref="editInfoFormRef" :rules="editInfoRules"
              style="width: 100%">
              <el-row>
                <el-col :span="24" align="center">
                  <div class="tit">客户信息</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="赛区" prop="districtId">
                    <el-select placeholder="请选择" v-model="editInfoForm.districtId" @change="distChange"
                      style="width: 100%">
                      <el-option v-for="item in dict_district" :key="item.id" :label="item.districtName"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="省市区" prop="schoolArea">
                    <el-cascader placeholder="请选择" v-model="editInfoForm.schoolArea" ref="schoolAreaRef"
                      :options="areasData" style="width: 100%" :props="{
                        expandTrigger: 'hover',
                        label: 'name',
                        value: 'areaId',
                        children: 'areas',
                      }" @change="provincesHandleChange()"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="客户名称" prop="schoolName">
                    <el-input style="width: 70%;margin-right: 12px;" v-model="editInfoForm.schoolName" placeholder="请输入"></el-input>
                    <el-button type="warning" @click="searchFn">查询</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户类型" prop="schoolType">
                    <el-select placeholder="请选择" v-model="editInfoForm.schoolType" style="width: 100%">
                      <el-option v-for="item in dict_schoolType" :key="item.dictCode" :label="item.dictLabel"
                        :value="item.dictValue"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="参赛经历" prop="attendType">
                    <el-select placeholder="请选择" v-model="editInfoForm.attendType" style="width: 100%">
                      <el-option v-for="item in dict_attendType" :key="item.dictCode" :label="item.dictLabel"
                        :value="item.dictValue"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="参赛类型" prop="typeflag">
                    <el-select placeholder="请选择" v-model="editInfoForm.typeflag" style="width: 100%">
                      <el-option v-for="item in dict_competition" :key="item.dictCode" :label="item.dictLabel"
                        :value="item.dictValue"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系地址" prop="schoolAddress">
                    <el-input v-model="editInfoForm.schoolAddress" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包含组别" prop="schoolLevels">
                    <el-select @change="$forceUpdate()" placeholder="请选择" style="width: 100%"
                      v-model="editInfoForm.schoolLevels" multiple>
                      <el-option v-for="item in dict_group" :key="item.dictCode" :label="item.dictLabel"
                        :value="item.dictValue"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="拓展人" prop="expander">
                    <el-input v-model="editInfoForm.expander" placeholder="请输入拓展人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :row="2" v-model="editInfoForm.remark" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24" align="center">
                  <el-button type="primary" style="width: 180px;margin-top: 12px;" @click="saveClicked">保 存</el-button>
                </el-col>
              </el-row>
            </el-Form>
          </div>
        </el-card>
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">B端客户数据池</span>
            </el-col>
          </el-row>
          <el-row :gutter="30" style="margin-top: 34px">
            <el-col :span="10" v-for="(item, i) of dataManagementList" v-bind:key="i">
              <gameToolBackView :itemData="item" :key="i" @itemClicked="racingToolClicked"></gameToolBackView>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <!-- 右侧留空 -->
      <el-col :span="10">
        <el-card style=" height: 264px;">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">待分配客户</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="text" size="mini" style="color: #1f30c7;" @click="handleTolist(1)">更多 >></el-button>
            </el-col>
          </el-row>
          <div v-for="(item, i) in unassignedList" :key="i" class="customer-item">
            <!-- 左侧客户信息 -->
            <div class="customer-info">
              <div class="customer-name">{{ item.schoolName }}</div>
              <div class="customer-contact">{{ item.expander }} ｜ {{ item.districtName }} | {{ item.schoolAddress }}</div>
            </div>
            <!-- 右侧按钮 -->
            <div class="customer-action">
              <el-button type="primary" size="mini" plain @click="onAssign(item)">分配客户</el-button>
            </div>
          </div>
          <el-empty v-if="!unassignedList.length" :image-size="60"></el-empty>
        </el-card>
        <el-card style="margin-top: 15px; height: 280px;">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">跟进中客户</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="text" size="mini" style="color: #1f30c7;" @click="handleTolist(2)">更多 >></el-button>
            </el-col>
          </el-row>
          <div class="timeline-wrapper">
            <div v-for="(item, i) in activityList" :key="i" class="timeline-node">
              <!-- <div class="timeline-dot"></div> -->
              <div class="timeline-card" :style="{ background: getCardBg(item.statusType) }">
                <div class="card-left">
                  <div class="card-name">{{ item.school.schoolName }}</div>
                  <div class="card-contact">{{ item.recipientUser.userName }} ｜ {{ item.school.schoolAddress }}</div>
                </div>
                <div class="card-right">
                  <el-tag size="small" effect="plain" :type="guestStatusFilter(item.guestStatus).type">{{ guestStatusFilter(item.guestStatus).text }}</el-tag>
                  <el-button type="text" size="small" @click="onViewDetail(item)">跟进记录</el-button>
                </div>
              </div>
            </div>
            <el-empty v-if="!activityList.length" :image-size="60"></el-empty>
          </div>
        </el-card>
        <el-card style="margin-top: 15px; height: 280px;">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">我的客户</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="text" size="mini" style="color: #1f30c7;" @click="handleTolist(3)">更多 >></el-button>
            </el-col>
          </el-row>
          <div class="timeline-wrapper">
            <div v-for="(item, i) in activityList2" :key="i" class="timeline-node">
              <!-- <div class="timeline-dot"></div> -->
              <div class="timeline-card" :style="{ background: getCardBg(item.statusType) }">
                <div class="card-left">
                  <div class="card-name">{{ item.school.schoolName }}</div>
                  <div class="card-contact">{{ item.school.schoolAddress }}</div>
                </div>
                <div class="card-right">
                  <el-tag size="small" effect="plain" :type="guestStatusFilter(item.guestStatus).type">{{ guestStatusFilter(item.guestStatus).text }}</el-tag>
                  <el-button type="text" size="small" @click="onViewDetail(item)">跟进记录</el-button>
                </div>
              </div>
            </div>
            <el-empty v-if="!activityList2.length" :image-size="60"></el-empty>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 分配客户弹窗 -->
    <el-dialog title="分配客户" :visible.sync="assignVisible" width="420px" :close-on-click-modal="false" append-to-body>
      <el-form :model="assignForm" label-width="90px">
        <el-form-item label="负责人">
          <el-select v-model="assignForm.recipientUserId" placeholder="请选择接收人" style="width: 100%">
            <el-option v-for="item in childUserList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center; font-size: 12px; color: #f00;">只分配本赛季数据</div>
      <span slot="footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" :loading="assignLoading" @click="submitAssign">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 学校查询结果弹窗 -->
    <el-dialog title="查询结果" :visible.sync="schoolSearchVisible" width="800px" append-to-body>
      <el-alert
        v-if="schoolSearchList.length > 0"
        :title="schoolSearchAlertTitle"
        type="info"
        :closable="false"
        style="margin-bottom: 16px"
      ></el-alert>
      <el-table :data="schoolSearchList" border stripe>
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="客户省市区" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ getAreaText(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="客户名称" prop="schoolName" min-width="200"></el-table-column>
        <el-table-column label="赛区" prop="districtName" min-width="120"></el-table-column>
        <!-- <el-table-column label="创建人" prop="creator" min-width="120"></el-table-column> -->
      </el-table>
    </el-dialog>

    <SchoolTrackRecordDialog :visible.sync="trackRecordVisible" :row="currentRow" :schoolTypeList="schoolTypeList"></SchoolTrackRecordDialog>
  </div>
</template>

<script>
import { addSysSchool, queryDistrictPage, getSchoolContactInfo, getAllAreaList, saveSysUserBatch, getDictList } from '@/http/api'
import SchoolTrackRecordDialog from './components/SchoolTrackRecordDialog.vue'

// import OfflineOrder from '../product_Management/order/offline_order.vue'

export default {
  name: 'marketingOperationsHome',
  components: {
    SchoolTrackRecordDialog
  },
  data () {
    return {
      index: 0,
      trackRecordVisible: false,
      currentRow: {},
      schoolTypeList: [],
      dataManagementList: [
        {
          icon: 'icon-xuexiao_xuexiaoxinxi',
          rightTitle: '学校/机构管理',
          rightDesc: '可新增、修改、审核学校/机构信息',
          path: '/system_data_Management/system_school_management',
          menuTag: '2',
          flag: this.$chnEngStatusCode.b_school_management
        }
      ],
      info: [{
        icon: 'icon-shenhetongguo',
        rightTitle: '考量申请审核',
        rightDesc: '个人赛考量申请审核管理',
        path: '/individual_racing_tool/individual_school_considerations',
        menuTag: '4',
        flag: this.$chnEngStatusCode.paper_application_management
      }],
      toolList: [
        // TODO: 添加菜单项
      ],
      unassignedList: [
      ],
      myCustomerList: [
        { title: '客户总量', number: 100 },
        { title: '已成交', number: 20 },
        { title: '待跟进', number: 80 }
      ],
      salespersonList: [
        { id: 1, name: '张三' },
        { id: 2, name: '李四' },
        { id: 3, name: '王五' }
      ],
      activityList: [
      ],
      activityList2: [],
      editInfoForm: {
        districtId: '',
        schoolArea: '',
        schoolName: '',
        schoolType: '',
        attendType: '',
        typeflag: '',
        schoolAddress: '',
        schoolLevels: '',
        expander: '',
        remark: ''
      },
      editInfoRules: {
        schoolLevels: [{ required: true, message: '请选择', trigger: 'change' }],
        districtId: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolName: [{ required: true, message: '请输入', trigger: 'blur' }],
        attendType: [{ required: true, message: '请选择', trigger: 'change' }],
        typeflag: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolType: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        nationality: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      dict_group: this.$userInfo.dict_group(),
      dict_schoolType: this.$userInfo.getDataList(this, 'school_type').then(value => { this.dict_schoolType = value }),
      dict_countries: this.$userInfo.dict_countries(),
      dict_competition: this.$userInfo.dict_competition(),
      dict_attendType: this.$userInfo.dict_attendType2(),
      dict_district: [],
      areasData: [],
      activeIndex: 0,
      batchStep: 0, // 批量新增步骤
      uploadedDataCount: 0, // 上传的数据条数
      uploadedFileName: '', // 上传的文件名
      selectedFile: null, // 选择的文件对象
      uploadFileList: [], // 上传组件的文件列表
      addInfoForm: {
        addUserList: [
          {
            phone: '',
            userName: ''
          }
        ]
      },
      addInfoRules: {
        'addUserList.phone': [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      importWordExcel: {
        uploadUrl: this.$env.baseIP + 'erpUser/importSysUserBatch',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        },
        districtId: null
      },
      // 分配客户弹窗
      assignVisible: false,
      assignLoading: false,
      assignForm: {
        recipientUserId: ''
      },
      childUserList: [],
      schoolSearchVisible: false,
      schoolSearchList: [],
      schoolSearchKeyword: ''
    }
  },
  watch: {
    trackRecordVisible (val) {
      if (!val) {
        this.getRightList2()
        this.getRightList3()
      }
    }
  },
  computed: {
    schoolSearchAlertTitle () {
      return '查询到 ' + this.schoolSearchList.length + ' 条包含 "' + this.schoolSearchKeyword + '" 的数据，请勿重复添加。'
    }
  },
  created () {
    this.getDistrictList()
    this.getAllAreaList()
    this.getRightList1()
    this.getRightList2()
    this.getRightList3()
    this.getSchoolTypeList()
  },
  methods: {
    // 获取客户类型字典
    // 查询学校
    searchFn () {
      const name = (this.editInfoForm.schoolName || '').trim()
      if (!name) {
        this.$message.warning('请输入学校名称')
        return
      }
      this.schoolSearchKeyword = name
      this.$http.get('school/getListByName', { params: { schoolName: name } }).then((res) => {
        if (res.code === 200) {
          this.schoolSearchList = res.data || []
          this.schoolSearchVisible = true
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        this.$message.error('查询失败')
      })
    },
    // 拼接省市区文字
    getAreaText (row) {
      if (!row) return '-'
      return [row.province, row.city, row.area].filter(v => v).join('') || '-'
    },
    getSchoolTypeList () {
      getDictList({ dictType: 'school_type' }).then((res) => {
        if (res.code === 200) {
          this.schoolTypeList = res.data || []
        }
      }).catch((err) => {
        console.log('getSchoolTypeList err', err)
      })
    },
    // 待分配
    getRightList1 () {
      this.$http.get('schoolTrack/unassignedList', { params: { pageNum: 1, pageSize: 3 } }).then(res => {
        if (res.code === 200) {
          this.unassignedList = res.data.list
        }
      })
    },
    // 待跟进
    getRightList2 () {
      this.$http.get('schoolTrack/unFollowUp?pageNum=1&pageSize=3&guestStatus=-1&guestStatus=1').then(res => {
        if (res.code === 200) {
          this.activityList = res.data.list
        }
      })
    },
    // 我的客户
    getRightList3 () {
      this.$http.get('schoolTrack/assignedMyList?pageNum=1&pageSize=3').then(res => {
        if (res.code === 200) {
          this.activityList2 = res.data.list
        }
      })
    },
    handleTolist (type) {
      if (type === 1) {
        this.$router.push('/marketing_operations/unassigned_customer_list')
      } else if (type === 2) {
        this.$router.push('/marketing_operations/follow_up_customer_list?type=1')
      } else if (type === 3) {
        this.$router.push('/marketing_operations/follow_up_customer_list?type=2')
      }
    },
    racingToolClicked (itemData) {
      if (itemData.path) {
        this.$router.push(itemData.path)
      }
    },
    toolClicked (item) {
      if (!item.turnUrl) return
      this.$router.push(item.turnUrl)
    },
    // 获取可分配的子用户列表
    getChildUserList () {
      if (this.childUserList.length) return
      this.$http.get('erp/getChildUser').then(res => {
        if (res.code === 200) {
          const list = (res.data && (res.data.list || res.data)) || []
          this.childUserList = Array.isArray(list) ? list : []
        }
      }).catch((err) => {
        console.log('getChildUserList err', err)
        this.$message.error('获取接收人列表失败')
      })
    },
    // 点击分配
    onAssign (item) {
      this.currentRow = item
      this.assignForm.recipientUserId = ''
      this.assignVisible = true
      this.getChildUserList()
    },
    // 提交分配
    submitAssign () {
      if (!this.assignForm.recipientUserId) {
        this.$message.warning('请选择接收人')
        return
      }
      this.assignLoading = true
      this.$http.post('schoolTrack/allocation', {
        recipientUserId: this.assignForm.recipientUserId,
        schoolId: this.currentRow.id
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('分配成功')
          this.assignVisible = false
          this.getRightList1()
          this.getRightList2()
          this.getRightList3()
        } else {
          this.$message.error(res.msg || '分配失败')
        }
        this.assignLoading = false
      }).catch((err) => {
        console.log('submitAssign err', err)
        this.$message.error('分配失败')
        this.assignLoading = false
      })
    },
    getCardBg (statusType) {
      const map = ['#ecf5ff', '#faecd8', '#e1f3d8', '#fde2e2']
      return map[statusType] || '#ecf5ff'
    },
    // 客单状态映射：-1待跟进 1跟进中 2已参赛 3已拒绝
    guestStatusFilter (val) {
      const map = {
        '-1': { text: '待跟进', type: 'warning' },
        1: { text: '跟进中', type: '' },
        2: { text: '已参赛', type: 'success' },
        3: { text: '已拒绝', type: 'danger' }
      }
      return map[String(val)] || { text: '未知', type: 'info' }
    },
    onViewDetail (item) {
      this.currentRow = item
      this.trackRecordVisible = true
    },
    getAllAreaList () {
      getAllAreaList({}).then((res) => {
        this.areasData = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        console.log('this.editInfoForm', this.editInfoForm)
        if (this.editInfoForm.id) {
          this.getSchoolContactsData()
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getSchoolContactsData () {
      getSchoolContactInfo(this.editInfoForm.id).then(res => {
        console.log('getSchoolContactInfo', res)
        this.editInfoForm.contactsList = res.data.contactsList
        this.$forceUpdate()
      })
    },
    // 保存学校信息
    saveClicked () {
      console.log('editInfoForm', this.editInfoForm)
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return
        this.editInfoForm.schoolLevel = this.editInfoForm.schoolLevels.join(',')
        addSysSchool(this.editInfoForm).then((res) => {
          this.$message.success('操作成功')
          this.$refs.editInfoFormRef.resetFields()
          this.getRightList1()
        }).catch((err) => {
          console.log('err', err)
        })
      })
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      console.log('value', value)
      this.editInfoForm.provinceCode = this.editInfoForm.schoolArea[0]
      this.editInfoForm.cityCode = this.editInfoForm.schoolArea[1]
      this.editInfoForm.areaCode = this.editInfoForm.schoolArea[2]
      const deliveryAreaName = this.$refs.schoolAreaRef.getCheckedNodes()[0].pathLabels.join('/')
      const areaList = deliveryAreaName.split('/')
      this.editInfoForm.province = areaList[0]
      this.editInfoForm.city = areaList[1]
      this.editInfoForm.area = areaList[2]
    },
    distChange (e) {
      this.editInfoForm.districtName = this.dict_district.find(item => item.id === e).districtName
    },
    // 下载模板
    downloadTemplate () {
      // 这里添加下载模板的逻辑
      var downLoadUrl = this.$env.baseIP + 'erpUser/downloadExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', {})
      this.$message.success('模板下载成功')
      this.batchStep = 1 // 自动进入下一步
    },
    // 跳过下载直接上传
    skipToUpload () {
      this.batchStep = 1 // 直接进入上传步骤
    },
    // 上传前验证
    beforeUpload (file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                     file.type === 'application/vnd.ms-excel'

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return false
      }

      return true
    },
    // 文件选择变化处理
    handleFileChange (file, fileList) {
      if (file.status === 'ready') {
        this.selectedFile = file.raw
        this.uploadedFileName = file.name
        this.uploadFileList = fileList // 保存文件列表状态
        this.$message.success('文件选择成功，请进入下一步进行确认导入')
      }
    },
    // 文件移除处理
    handleFileRemove (file, fileList) {
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = fileList
    },
    // 上传成功
    uploadSuccess (response, file) {
      console.log('上传成功响应:', response)
      if (response && response.code === 200) {
        this.$message.success('文件上传并导入成功')
        // 直接关闭弹窗并刷新数据
        this.closeBatchDialog()
        this.getDataList('search')
      } else {
        this.$message.error(response.msg || '文件导入失败')
      }
    },
    // 上传失败
    uploadError (error) {
      console.log('上传失败:', error)
      this.$message.error('文件上传失败，请重试')
    },
    // 确认上传
    confirmUpload () {
      // 验证赛区是否选择
      if (!this.importWordExcel.districtId) {
        this.$message.warning('请选择赛区')
        return
      }

      // 验证文件是否选择
      if (!this.selectedFile) {
        this.$message.warning('请先选择要上传的文件')
        return
      }

      // 创建FormData对象进行文件上传
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('districtId', this.importWordExcel.districtId)

      // 使用axios进行文件上传
      this.$http.post(this.importWordExcel.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...this.importWordExcel.headerObj
        }
      }).then(response => {
        console.log('上传成功响应:', response)
        if (response && response.code === 200) {
          this.$message.success('文件上传并导入成功')
          this.closeBatchDialog()
          this.getDataList('search')
        } else {
          this.$message.error(response.msg || '文件导入失败')
        }
      }).catch(error => {
        console.log('上传失败:', error)
        this.$message.error('文件上传失败，请重试')
      })
    },

    // 上一步
    prevStep () {
      if (this.batchStep > 0) {
        this.batchStep--
      }
    },
    // 下一步
    nextStep () {
      if (this.batchStep < 2) {
        this.batchStep++
      }
    },
    // 添加选手信息
    addClicked () {
      this.addInfoForm.addUserList.push({
        phone: '',
        userName: ''
      })
    },
    // 减少选手信息
    subtractClicked (e) {
      console.log('e', e)
      this.addInfoForm.addUserList.splice(e, 1)
    },
    // 新增用户请求
    addUserInfoClicked () {
      console.log('this.addInfoForm', this.addInfoForm)
      saveSysUserBatch(this.addInfoForm.addUserList).then((res) => {
        this.addUserDialogVisible = false
        this.$message.success('添加成功')
        this.getDataList('search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.customer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid #ebeef5;
  &:last-child {
    border-bottom: none;
  }
  .customer-info {
    flex: 1;
    .customer-name {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 4px;
    }
    .customer-contact {
      font-size: 12px;
      color: #909399;
    }
  }
  .customer-action {
    margin-left: 10px;
  }
}

/* 客户动态 - 节点轴 */
.timeline-wrapper {
  position: relative;
  // padding: 0 0 0 20px;
  // &::before {
  //   content: '';
  //   position: absolute;
  //   left: 10px;
  //   top: 16px;
  //   bottom: 16px;
  //   width: 2px;
  //   background: #dcdfe6;
  // }
}

.timeline-node {
  position: relative;
  // padding-left: 20px;
  padding-bottom: 10px;
  &:last-child {
    padding-bottom: 0;
  }
}

.timeline-dot {
  position: absolute;
  left: -15px;
  top: 22px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #409eff;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #409eff;
  z-index: 1;
}

.timeline-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  padding: 8px 14px;
  .card-left {
    flex: 1;
    .card-name {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 4px;
    }
    .card-contact {
      font-size: 12px;
      color: #909399;
    }
  }
  .card-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
}
.flex{
  display: flex;
  .btns{
    width: 40px;
    padding-top: 20px;
    .btn{
      width: 44px;
      border: 1px solid #409eff;
      color: #409eff;
      font-size: 14px;
      border-radius: 6px;
      margin-bottom: 40px;
      padding: 14px;
      box-sizing: border-box;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      &.active{
        background-color: #409eff;
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
.form{
  background-color: #ECF5FF;
  padding: 20px 30px;
}
.tit{
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}
.add-container{
  border: 1px dashed #b3d8ff;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: #ecf5ff;
  margin-left: 20px;
  padding: 14px 0;
  width: 100%;
  p{
    text-align: center;
    font-size: 12px;
    color: #909399;
  }
  h5{
    text-align: center;
    margin: 4px 0;
  }
  .step-icon{
    font-size: 18px;
    text-align: center;
  }
}
.template-actions{
  text-align: center;
}
.batch-actions{
  text-align: center;
  margin-top: 10px;
}
::v-deep .el-upload-dragger{
  height: 120px;
  .el-icon-upload{
    font-size: 30px;
    margin: 10px;
  }
}
.upload-demo{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.step-content {
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
}
/* 单项新增弹窗样式 */
.single-add-container {
  // padding: 20px 0;
}

.add-user-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-left: 20px;
  // padding: 20px;
  // background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  // border-radius: 10px;
}

.header-icon {
  font-size: 30px;
  color: #409eff;
  margin-right: 10px;
}

.header-text h3 {
  margin: 0 0 5px 0;
  color: #000;
  font-size: 14px;
}

.header-text p {
  margin: 0;
  color: #909399;
  font-size: 12px;
}

.user-form {
  max-height: 400px;
  overflow-y: auto;
}

.user-list {
  padding: 10px 0;
}

.user-item {
  margin-bottom: 25px;
  padding: 10px 14px;
  margin-left: 10px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fff;
  transition: all 0.3s ease;
}

.user-item:hover {
  border-color: #409eff;
  background: #f8f9fa;
}

.user-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e6e6e6;
}

.user-number {
  font-weight: bold;
  color: #409eff;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
}
</style>
